<template>
  <main class="ap-page">
    <!-- HERO -->
    <header class="ap-hero">
      <div class="ap-hero-inner">
        <div class="ap-underLogoPhrase">
          <h1 class="font-weight-bold mb-4 centers">
            <span class="marker">Les Animaux S.O.S</span>
          </h1>
          <p class="littlesize">Urgent !</p>
        </div>
      </div>
    </header>

    <!-- CONTENT -->
    <section class="ap-content">
      <!-- GRID -->
      <div class="grid">
        <router-link
          v-for="animau in animauxFiltres"
          :key="animau.id"
          :to="'/animaux/' + animau.id"
          class="card-link"
        >
          <div class="animal-card">
            <div class="animal-image">
              <img
                :src="getImage(animau)"
                :alt="animau.type + ' ' + animau.name"
                loading="lazy"
              />
            </div>
            <div class="animal-info">
              <h5 class="animal-name">
                {{ animau.name }}
                <span class="animal-icon">{{ animau.type === 'chat' ? '🐱' : '🐶' }}</span>
              </h5>
              <p class="animal-detail"><strong>Âge :</strong> {{ calculateAge(animau.naissance) }}</p>
              <p class="animal-detail"><strong>Race :</strong> {{ animau.race }}</p>
              <p class="animal-detail" v-if="animau.huge_information">
                <strong style="color:red">{{ animau.huge_information }}</strong>
              </p>
            </div>
          </div>
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
import convertAge from '../components/getAge.js';

export default {
  data() {
    return {
      animaux: [],
      animauxFiltres: []
    };
  },

  mounted() {
    const idSite = this.$idSite;
    fetch(`https://admin.asso-refuge.fr/getSos/${idSite}`)
      .then(response => response.json())
      .then(data => {
        this.animaux = data;
        this.appliquerFiltre();
      })
      .catch(error => {
        console.error('Il y a eu un problème avec votre requête :', error.message);
      });
  },

  methods: {
    appliquerFiltre() {
      const type = this.$route.query.type || 'all';
      this.animauxFiltres = type === 'all'
        ? this.animaux
        : this.animaux.filter(animal => animal.type === type);
    },
    filtrerAnimaux(type) {
      this.$router.push({ path: this.$route.path, query: { type } });
    },
    calculateAge(dateOfBirth) {
      return convertAge(dateOfBirth);
    },
    getImage(animal) {
      if (animal.img1) return 'https://admin.asso-refuge.fr/images/' + animal.img1;
      return animal.type === 'chat'
        ? 'https://www.admin.spadesavoie.fr/images/chatmanquant.png'
        : 'https://www.admin.spadesavoie.fr/images/chienmanquant.png';
    }
  },

  watch: {
    '$route.query.type': 'appliquerFiltre'
  }
};
</script>

<style scoped src="../assets/css/animauxnew.css"></style>
